import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation.tsx';
import { cn } from '@helpers/cn';
import { Button, Input, Tooltip } from '@eye-able/ui';
import type { InputProps } from '@eye-able/ui';
import { IconEye, IconEyeOff } from '@tabler/icons-react';
import { forwardRef, useState } from 'react';

export interface PasswordInputProps extends InputProps {
  wrapperClassName?: string;
}

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  function PasswordInput({ className, wrapperClassName, ...props }, ref) {
    const { t } = useInlineTranslation();
    const [showPassword, setShowPassword] = useState(false);
    const tooltipText = t(showPassword ? 'hidePassword' : 'showPassword');

    return (
      <div className={cn('eye:relative eye:w-full', wrapperClassName)}>
        <Input
          ref={ref}
          type={showPassword ? 'text' : 'password'}
          className={cn('eye:pr-48', className)}
          {...props}
        />
        <Tooltip content={tooltipText}>
          <Button
            type='button'
            variant='ghost'
            size='icon-xs'
            className='eye:absolute eye:right-12 eye:top-1/2 eye:z-10 eye:-translate-y-1/2'
            aria-label={tooltipText}
            onClick={() => setShowPassword((prev) => !prev)}
          >
            {showPassword ? <IconEyeOff /> : <IconEye />}
          </Button>
        </Tooltip>
      </div>
    );
  },
);

export default PasswordInput;
